const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

let subscribers = {}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback
    });
  }
};

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data)
    })
  }
}

// Polyfill for requestIdleCallback
window.requestIdleCallback = window.requestIdleCallback || function(cb) {
  const start = Date.now();
  return setTimeout(() => {
    cb({
      didTimeout: false,
      timeRemaining: () => Math.max(0, 50 - (Date.now() - start))
    });
  }, 1);
};

window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
  clearTimeout(id);
};

// Polyfill for scheduler.yield() - breaks up long tasks
async function yieldToMain() {
  if ('scheduler' in window && 'yield' in scheduler) {
    return scheduler.yield();
  }

  return new Promise(resolve => {
    setTimeout(resolve, 0);
  });
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
    if (document.querySelector("#header-section-overlay") !== null) {
      if (
        !event.currentTarget.closest("details").hasAttribute("open") &&
        !event.target.closest("summary").classList.contains("mobile-facets__summary") &&
        !event.target.closest("summary").classList.contains("share-button__button")
      )  {
        document.querySelector("#header-section-overlay").style.display =
          "block";
      } else {
        document.querySelector("#header-section-overlay").style.display =
          "none";
      }
    }
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  try {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;

      document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        requestAnimationFrame(() => {
          first.focus();
        })
      }

      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        requestAnimationFrame(() => {
          last.focus();
        })
      }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);
    if (elementToFocus !== null) {
      requestAnimationFrame(() => {
        elementToFocus.focus();
      })
      if (
        elementToFocus.tagName === "INPUT" &&
        ["search", "text", "email", "url"].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    }
  } catch (e) {
    console.error("error", e);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null, focus = true) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus && focus) {
    requestAnimationFrame(() => {
      elementToFocus.focus();
    })
  }
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  _clearStickyQtyWidgetRefs() {
    this.stickyQuantityInput = null;
    this.stickyInput = null;
    this.stickyButtonPlus = null;
    this.stickyButtonMinus = null;
  }

  _clearMobileQtyWidgetRefs() {
    this.mobileQuantityInput = null;
    this.mobileButtonPlus = null;
    this.mobileButtonMinus = null;
  }

  _clearSharedQtyWidgetRefs() {
    this._clearStickyQtyWidgetRefs();
    this._clearMobileQtyWidgetRefs();
  }

  constructor() {
    super();
    // Only main PDP desktop qty (.qqty) may sync and drive sticky + mobile +/-.
    // Other quantity-input instances must not query those nodes or validateQtyRules
    // would disable minus at min using their own stale value (e.g. 1 while cart is 10).
    if (!this.classList.contains("qqty")) {
      this._clearSharedQtyWidgetRefs();
    } else {
      const sticky = document.querySelector('sticky-quantity-input.sticky-qty-atc');
      this.stickyQuantityInput = sticky;
      this.stickyInput = sticky?.querySelector("input") ?? null;
      this.stickyButtonPlus = sticky?.querySelector('.quantity__button[name="plus"]') ?? null;
      this.stickyButtonMinus = sticky?.querySelector('.quantity__button[name="minus"]') ?? null;

      const mobile = document.querySelector(".mobile_qty_atc_flex quantity-input");
      this.mobileQuantityInput = mobile;
      this.mobileButtonPlus = mobile?.querySelector(".quantity__button[name='plus']") ?? null;
      this.mobileButtonMinus = mobile?.querySelector(".quantity__button[name='minus']") ?? null;
    }

    this.input = this.querySelector("input");
    this.buttonPlus = this.querySelector(".quantity__button[name='plus']");
    this.buttonMinus = this.querySelector(".quantity__button[name='minus']");

    this._onInputChange = this.onInputChange.bind(this);
    this._onButtonClick = this.onButtonClick.bind(this);
    this.changeEvent = new Event("change", { bubbles: true });

    if (this.input) {
      this.input.addEventListener("change", this._onInputChange);
    }
    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this._onButtonClick);
    });
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    const isRedirectedByCheckout = localStorage.getItem('redirectionTarget') === 'checkout' || null ;
    // JW FLAG: commented code as it is older logic for giftcard and not credit wallet related 
    // if (!isRedirectedByCheckout) {
    //    fetchCardDetails("connectedCallback-Qty");
    // }
    
    // Call the function to handle STC Breeze Checkout setup
    // blocked stcBreezeCheckout function call on fetchCardDetails triggered from QuantityInput connected callback method
    stcBreezeCheckout();

    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    if(this.stickyInput) {
      this.stickyInput.value = this.input.value;
    }
    if (this.mobileQuantityInput) {
      this.mobileQuantityInput.querySelector("input").value = this.input.value;
    }
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  validateQtyRules(variantInventory = null) {
    const value = parseInt(this.input.value);
    const min = parseInt(this.input.min) || 1;
    const max = variantInventory !== null ? variantInventory : (parseInt(this.input.max) || Infinity);

    const updateButton = (button, stickyButton, mobileButton, isDisabled) => {
      button.disabled = isDisabled;
      button.classList.toggle("disabled", isDisabled);
      // sticky/mobile only set on .qqty; null on other instances skips these branches.
      if (stickyButton) {
        stickyButton.disabled = isDisabled;
        stickyButton.classList.toggle("disabled", isDisabled);
      }
      if (mobileButton) {
        mobileButton.disabled = isDisabled;
        mobileButton.classList.toggle("disabled", isDisabled);
      }
    };

    updateButton(this.buttonMinus, this.stickyButtonMinus, this.mobileButtonMinus, value <= min);
    updateButton(this.buttonPlus, this.stickyButtonPlus, this.mobileButtonPlus, value >= max);
  }

  validateQtyRulesOnVariantChange(variantInventory) {
    setTimeout(() => this.validateQtyRules(variantInventory), 100);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
    if (
      document.querySelector("body").style.overflow == "hidden" &&
      !document
        .querySelector("body")
        .classList.contains("overflow-hidden-mobile")
    )
      setTimeout(() => {
        document.querySelector("body").style.overflow = null;
      })
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    // Bind once and store references
    this.boundOnKeyUp = this.onKeyUp.bind(this);
    this.boundOnFocusOut = this.onFocusOut.bind(this);
    this.boundOnSummaryClick = this.onSummaryClick.bind(this);
    this.boundOnCloseButtonClick = this.onCloseButtonClick.bind(this);

    this.addEventListener("keyup", this.boundOnKeyUp);
    this.addEventListener("focusout", this.boundOnFocusOut);
    this.bindEvents();
  }

  bindEvents() {
    // Use stored bound references for removal and addition
    this.querySelectorAll("summary").forEach((summary) => {
      summary.removeEventListener("click", this.boundOnSummaryClick);
      summary.addEventListener("click", this.boundOnSummaryClick);
    });

    this.querySelectorAll("button:not(.localization-selector)").forEach((button) => {
      button.removeEventListener("click", this.boundOnCloseButtonClick);
      button.addEventListener("click", this.boundOnCloseButtonClick);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    let flag = true;
    let showAllElements = false;
    let openButton = false;
    let accordianHead = document.querySelector(".accordion-head");
    if (detailsElement.classList.contains("main-filter-button") && screen.width <= 600 && flag) {
      flag = false;
      requestAnimationFrame(() => {
        accordianHead.closest('details').setAttribute("open", true);
        accordianHead.closest('details').style.background = "linear-gradient(0deg, rgba(66, 139, 193, 0.17), rgba(66, 139, 193, 0.17))";
        detailsElement.style.background = "#FFFFFF";
      })
    }

    document.querySelectorAll(".custom-size-ul li")?.forEach((x) => {
      if (x.classList.contains("SelectedSize") && x.classList.contains("show-more-item")) {
        showAllElements = true;
      }
      if (x.classList.contains("hidden")) openButton = true;
    });
    if (showAllElements && openButton && document.querySelector(".label-show-more")) {
      document.querySelector(".label-show-more").click();
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      detailsElement.classList.add("menu-opening");
      summaryElement.setAttribute("aria-expanded", true);

      // For Desktop
      if (event.target && screen.width > 600) {
        if (event.target.closest(" div").querySelector(".desk-arrow svg") != null) {
          const summaryElements = document.querySelectorAll(".accordion-head");
          const detailsElements = document.querySelectorAll(".custom-filter-design");
          summaryElements?.forEach((summary, index) => {
            summary.addEventListener("click", () => {
              detailsElements.forEach((details, i) => {
                if (index !== i) {
                  details.removeAttribute("open");
                }
              });
            });
          });
      }

      event.target.closest("details")?.scrollIntoView({ behavior: "smooth" });

      if (document.querySelector(".main-filter-button").classList.contains("menu-opening"))
        stopBodyScroll();
      else enableBodyScroll();
      parentMenuElement && parentMenuElement.classList.add("submenu-open");
      if (summaryElement.nextElementSibling !== null)
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }
      // For Mobile
      if (event.target && screen.width <= 600) {
        // Can't Remove this requestAnimationFrame
        requestAnimationFrame(() => {
          if (event.target.closest("details")) {
            if (event.target.closest("details").classList.contains("custom-filter-design")) {
              document.querySelectorAll(".mobile-facets__main.gradient details").forEach((detail) => {
                if (detail !== event.target.closest("details")) {
                  detail.removeAttribute("open");
                  detail.style.background = "#FFFFFF";
                } else {
                  detail.setAttribute("open", true);
                  detail.style.background = "linear-gradient(0deg, rgba(66, 139, 193, 0.17), rgba(66, 139, 193, 0.17)), #FFFFFF";
                }
              });
            }
          }
        });
      }
    }
  }

  openMenuDrawer(summaryElement) {
    this.mainDetailsToggle.classList.add("menu-opening");
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    setTimeout(() => {
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    })
     // Disable body scroll when filter drawer opens

    stopBodyScroll();

    if (screen.width <= 600 && this.mainDetailsToggle.classList.contains("main-filter-button")) {
      requestIdleCallback(() => {
        const filterContainer = document.querySelector(".mobile-facets__main.gradient");
        if (!filterContainer) return;

        const allFilterDetails = filterContainer.querySelectorAll("details.custom-filter-design");
        const firstFilter = filterContainer.querySelector("details.first_detail");

        allFilterDetails.forEach((detail) => {
          detail.removeAttribute("open");
          detail.style.background = "#FFFFFF";
        });

        if (firstFilter) {
          firstFilter.setAttribute("open", true);
          firstFilter.style.background = "linear-gradient(0deg, rgba(66, 139, 193, 0.17), rgba(66, 139, 193, 0.17)), #FFFFFF";
        }
      }, { timeout: 100 });
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    setTimeout(() => {
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    })
    // Enable body scroll when filter drawer closes
    enableBodyScroll();
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
    enableBodyScroll();
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    this.header = this.header || document.querySelector(".section-header");
    requestAnimationFrame(() => {
      this.headerBottom = parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset);
    })
  }

  openMenuDrawer(summaryElement) {
    // Immediate operations - needed for calculations and accessibility
    summaryElement.setAttribute("aria-expanded", true);

    // Calculate header position once
    // Batch visual DOM updates in requestAnimationFrame for smooth rendering
    document.documentElement.style.setProperty("--header-bottom-position", `${this.headerBottom}px`);

    this.header.classList.add("menu-open");
    this.mainDetailsToggle.classList.add("menu-opening");
    setTimeout(() => {
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    })

    // Focus trap should be set after visual updates
    trapFocus(this.mainDetailsToggle, summaryElement);

    // Defer non-critical event listener to idle time
    requestIdleCallback(() => {
      window.addEventListener("resize", this.onResize);
    });
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    requestAnimationFrame(() => {
      this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
      this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    });
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    setTimeout(() => {
      document.body.classList.add("overflow-hidden");
    })
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    setTimeout(() => {
      document.body.classList.remove("overflow-hidden");
    })
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange = async () => {
    // PHASE 1: Immediate critical updates
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.setUnavailable();
      return;
    }

    // PHASE 2: Update variant input (next frame)
    this.updateVariantInput();

    await yieldToMain();

    // PHASE 3: URL and pickup (deferred)
    this.updateURL();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    this.updateMedia();
    this.updateShareUrl();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const newErrorr = document.querySelector(".newErrorMessage");
    const newErrorrrWrapper = document.querySelector(".newErrorWrapper");
    newErrorrrWrapper.classList.add("hidden");
    newErrorr.innerText = "";
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo = async () => {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection || this.dataset.section;

    try {
      const response = await fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`
      );
      const responseText = await response.text();

      // Prevent stale updates
      if (this.currentVariant.id !== requestedVariantId) return;

      await yieldToMain();

      const html = new DOMParser().parseFromString(responseText, "text/html");

      // Batch updates with yields between each
      this._updatePriceInfo(html, sectionId);
      this._updateInventoryInfo(html, sectionId);
      this._updateSkuInfo(html, sectionId);
      this._updateAddButton(html, sectionId);

      await yieldToMain();

      // Publish change event
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      }

      // External callbacks
      if (typeof checkSelected === 'function') {
        checkSelected();
      }

      const sizeChartPrice = document.querySelector(".sizechartPrice");
      if (sizeChartPrice && this.currentVariant?.price) {
        sizeChartPrice.innerText = this.currentVariant.price / 100;
      }
    } catch (error) {
      console.error('Error fetching variant info:', error);
    }
  }

  /*
    ┌─────────────────────────────────────────────────────────────────────────────┐
    │   Helper Functions Added for Render Product Info                            │
    └─────────────────────────────────────────────────────────────────────────────┘
  */
  _updatePriceInfo = (html, sectionId) => {
    const destination = document.getElementById(`price-${this.dataset.section}`);
    const source = html.getElementById(`price-${sectionId}`);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.classList.remove("visibility-hidden");
    }
  }

  _updateInventoryInfo = (html, sectionId) => {
    const inventorySource = html.getElementById(`Inventory-${sectionId}`);
    const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");
    }
  }

  _updateSkuInfo = (html, sectionId) => {
    const skuSource = html.getElementById(`Sku-${sectionId}`);
    const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);

    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden")
      );
    }
  }

  _updateAddButton = (html, sectionId) => {
    const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
    this.toggleAddButton(
      addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
      window.variantStrings.soldOut
    );
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const dumButton = document.querySelector(".mainNoclick");
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      dumButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      dumButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      if(!this.dataset.url) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            if(typeof relatedProductsSwiper === 'function'){
              relatedProductsSwiper();
            }
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

function preventDefault(e) {
  if (
    !e.target.closest('input[type="range"]') &&
    !e.target.closest("div")?.classList.contains("all-filter-option") &&
    !e.target.closest("details")?.classList.contains("custom-filter-design") &&
    !e.target.closest("#menu-drawer")?.classList.contains("active") &&
    !e.target.closest("img")?.classList.contains("img-fluid")
  )
    e.preventDefault();
}

function stopBodyScroll() {
  try {
    setTimeout(() => {
      if (document.querySelector("body").classList.contains("overflow-hidden-mobile")) {
        document.body.addEventListener("touchmove", preventDefault, { passive: false });
        const btnCloseElements = document.querySelectorAll(".btnClose");
        const detailsElements = document.querySelectorAll(".custom-filter-design");
        const customUlElements = document.querySelectorAll(".custom-ul-layout");
        const bodyStyle = document.body.style;
        const docStyle = document.documentElement.style;
        btnCloseElements.forEach((element) => {
          element.addEventListener("click", enableBodyScroll, { passive: true });
        });
        detailsElements.forEach((element) => {
          element.addEventListener("click", enableBodyScroll, { passive: true });
        });
        customUlElements.forEach((element) => {
          element.addEventListener("click", enableBodyScroll, { passive: true });
        });
        bodyStyle.overflow = "hidden";
        bodyStyle.width = "100%";
      }
    }, 100);
  } catch (e) {
    console.error("error", e);
  }
}

function enableBodyScroll() {
  try {
    setTimeout(() => {
      if (document.querySelector("body").style.overflow == "hidden" && document.querySelector("body").classList.contains("overflow-hidden-mobile") == false) {
        document.body.removeEventListener("touchmove", preventDefault);
        const btnCloseElements = document.querySelectorAll(".btnClose");
        const detailsElements = document.querySelectorAll(".custom-filter-design");
        const customUlElements = document.querySelectorAll(".custom-ul-layout");
        const bodyStyle = document.body.style;
        const docStyle = document.documentElement.style;
        btnCloseElements.forEach((element) => {
          element.removeEventListener("click", enableBodyScroll);
        });
        detailsElements.forEach((element) => {
          element.removeEventListener("click", enableBodyScroll);
        });
        customUlElements.forEach((element) => {
          element.removeEventListener("click", enableBodyScroll);
        });
        bodyStyle.removeProperty("overflow");
        bodyStyle.removeProperty("width");
        document.querySelector("body").style.overflow = null;
      }
    }, 100);
  } catch (e) {
    console.error("error", e);
  }
}

/*
  ┌─────────────────────────────────────────────────────────────────────────┐
  │ Header Menu                                                             │
  └─────────────────────────────────────────────────────────────────────────┘
*/
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);

/*
  ┌─────────────────────────────────────────────────────────────────────────┐
  │ Search form used instead of predictive Search                           │
  └─────────────────────────────────────────────────────────────────────────┘
*/

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this))
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden')
    } else if (this.input.value.length === 0  && !resetIsHidden) {
      this.resetButton.classList.add('hidden')
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a')
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

/*
  ┌─────────────────────────────────────────────────────────────────────────┐
  │ Global Helper Functions                                                 │
  └─────────────────────────────────────────────────────────────────────────┘
*/

let lastCartSignature = "";

function fetchCart(source = "") {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      CARTDATAITEMS = [...cart.items];

      const isNitroActive = sessionStorage.getItem("nitrox") === "nitro";
      const currentSignature = JSON.stringify(
        cart.items.map(item => ({
          id: item.variant_id,
          qty: item.quantity
        }))
      );
      if (source === "nitroUpdatingCart" && isNitroActive && typeof triggerNitroCartEvent === "function" &&
        currentSignature !== lastCartSignature && lastCartSignature !== "") {
        triggerNitroCartEvent(cart);
      }
      lastCartSignature = currentSignature;

      updateCart();
    })
    .catch((error) => {
      console.error('Error: Fetching Cart', error);
    });
}

/*
  ┌─────────────────────────────────────────────────────────────────────────┐
  │ Share Button Component                                                  │
  └─────────────────────────────────────────────────────────────────────────┘
*/
if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends DetailsDisclosure {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      } else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
        this.elements.shareSummary.focus();
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.elements.closeButton.classList.remove('hidden');
        this.elements.closeButton.focus();
      });
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }
  });
}

function createIntersectionObserver(elements, callback, options = {}) {
  const {
    threshold = 0,
    rootMargin = 0,
    root = null
  } = options;

  // Check if native Intersection Observer is supported
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(callback, {
      threshold,
      rootMargin: `${rootMargin}px`,
      root
    });

    elements.forEach(el => observer.observe(el));
    return observer;
  }

  // Fallback implementation
  let isObserving = true;
  const observedElements = new Map();

  // Initialize element states
  elements.forEach(el => {
    observedElements.set(el, { isIntersecting: false });
  });

  function checkIntersection() {
    if (!isObserving) return;

    const viewport = {
      top: window.pageYOffset - rootMargin,
      left: window.pageXOffset - rootMargin,
      bottom: window.pageYOffset + window.innerHeight + rootMargin,
      right: window.pageXOffset + window.innerWidth + rootMargin
    };

    const entries = [];

    observedElements.forEach((state, element) => {
      const rect = element.getBoundingClientRect();
      const elementBounds = {
        top: rect.top + window.pageYOffset,
        left: rect.left + window.pageXOffset,
        bottom: rect.bottom + window.pageYOffset,
        right: rect.right + window.pageXOffset,
        width: rect.width,
        height: rect.height
      };

      // Calculate intersection
      const intersectionTop = Math.max(viewport.top, elementBounds.top);
      const intersectionLeft = Math.max(viewport.left, elementBounds.left);
      const intersectionBottom = Math.min(viewport.bottom, elementBounds.bottom);
      const intersectionRight = Math.min(viewport.right, elementBounds.right);

      const intersectionWidth = Math.max(0, intersectionRight - intersectionLeft);
      const intersectionHeight = Math.max(0, intersectionBottom - intersectionTop);
      const intersectionArea = intersectionWidth * intersectionHeight;
      const elementArea = elementBounds.width * elementBounds.height;

      const intersectionRatio = elementArea > 0 ? intersectionArea / elementArea : 0;
      const isIntersecting = intersectionRatio >= threshold;

      // Only trigger callback if intersection state changed
      if (state.isIntersecting !== isIntersecting) {
        state.isIntersecting = isIntersecting;

        entries.push({
          target: element,
          isIntersecting,
          intersectionRatio,
          intersectionRect: {
            top: intersectionTop - window.pageYOffset,
            left: intersectionLeft - window.pageXOffset,
            bottom: intersectionBottom - window.pageYOffset,
            right: intersectionRight - window.pageXOffset,
            width: intersectionWidth,
            height: intersectionHeight
          },
          boundingClientRect: rect,
          rootBounds: {
            top: -rootMargin,
            left: -rootMargin,
            bottom: window.innerHeight + rootMargin,
            right: window.innerWidth + rootMargin,
            width: window.innerWidth + (rootMargin * 2),
            height: window.innerHeight + (rootMargin * 2)
          },
          time: Date.now()
        });
      }
    });

    if (entries.length > 0) {
      callback(entries);
    }
  }

  // Throttled scroll handler
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        checkIntersection();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Add event listeners
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  // Initial check
  checkIntersection();

  // Return observer-like object
  return {
    observe(element) {
      if (!observedElements.has(element)) {
        observedElements.set(element, { isIntersecting: false });
        checkIntersection();
      }
    },

    unobserve(element) {
      observedElements.delete(element);
    },

    disconnect() {
      isObserving = false;
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      observedElements.clear();
    }
  };
}

// Set viewport height CSS variable initially and on resize
function setHeaderHeight() {
  if (window.matchMedia("(max-width: 990px)").matches) {
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty('--header-height', `${document.querySelector('header').offsetHeight}px`);
      setTimeout(() => {
        document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(document.querySelector('header').getBoundingClientRect().bottom - 1)}px`);
      }, 0);
    });
  }
}

// Initialize viewport height on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setHeaderHeight);
} else {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      setHeaderHeight();
    });
  });
}

function renderHamburgerMenu() {
  const nav = document.querySelector('.nav-menu-tab-container');
  const buttons = document.querySelectorAll('.nav-menu-tab-container .nav-tab-button');
  const mobileNavWrapper = document.querySelector('.mobile-nav-container-wrapper');

  // Pre-calculated values stored on DOM load
  let buttonDataMap = {};
  const NAV_STYLE_CLASS_PREFIX = 'nav-button-style-';
  const NAV_DYNAMIC_STYLES_ID = 'nav-tab-dynamic-styles';

  // Background colors map
  const backgroundColors = {
    '0': '#008',
    '1': '#D33369',
    '2': '#60A55A',
    '3': 'linear-gradient(275.76deg, #221F20 -33.36%, #505050 139.52%)'
  };

  function initializeButtonData() {
    if (!nav || buttons.length === 0) return;
    const navRect = nav.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    buttonDataMap = {};
    buttons.forEach((button) => {
      const dataFilter = button.getAttribute('data-filter');
      if (dataFilter === null) return;
      const btnRect = button.getBoundingClientRect();
      const styleClassName = `${NAV_STYLE_CLASS_PREFIX}${parseInt(dataFilter, 10) + 1}`;
      buttonDataMap[dataFilter] = {
        styleClassName,
        left: (btnRect.left - navRect.left) + 'px',
        width: btnRect.width + 'px',
        background: backgroundColors[dataFilter] || '#008',
        transform: `translateX(-${windowWidth * parseInt(dataFilter, 10)}px)`
      };
    });
    //applyDynamicNavStyles();
  }

  function applyDynamicNavStyles() {
    const cssRules = Object.values(buttonDataMap).map((buttonData) => `.nav-menu-tab-container.${buttonData.styleClassName}{--left:${buttonData.left};--width:${buttonData.width};--background:${buttonData.background};}`).join('');

    let styleEl = document.getElementById(NAV_DYNAMIC_STYLES_ID);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = NAV_DYNAMIC_STYLES_ID;
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = cssRules;
  }

  function setNavStyleClass(styleClassName) {
    if (!nav || !styleClassName) return;
    Array.from(nav.classList).forEach((className) => {
      if (className.startsWith(NAV_STYLE_CLASS_PREFIX)) {
        nav.classList.remove(className);
        mobileNavWrapper.classList.remove(className);
      }
    });
    nav.classList.add(styleClassName);
    mobileNavWrapper.classList.add(styleClassName);
  }

  // Apply tab styles by setting CSS custom properties directly on elements
  function applyTabStyles(dataFilter) {
    // Click on Blogs Link
    if (dataFilter === 4) {
      buttons[4].click();
    }

    const buttonData = buttonDataMap[dataFilter];
    if (!buttonData) return;
    // Set CSS custom properties directly on elements via inline styles
    nav.style.setProperty('--left', buttonData.left);
    nav.style.setProperty('--width', buttonData.width);
    nav.style.setProperty('--background', buttonData.background);

    // setNavStyleClass(buttonData.styleClassName);
    if (mobileNavWrapper) {
      mobileNavWrapper.style.setProperty('--transform', buttonData.transform);
    }
    // Update active states on buttons
    buttons.forEach((button) => {
      if (button.getAttribute('data-filter') === `${dataFilter}`) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }

  window.applyTabStyles = applyTabStyles;

  // Initialize on DOM load
  if (nav && buttons.length > 0) {
    document.addEventListener('DOMContentLoaded', () => {
      // double rAF ensures layout is settled
      requestAnimationFrame(() => {
        requestAnimationFrame(initializeButtonData);
      });
    });
    window.addEventListener('load', () => {
      // double rAF ensures layout is settled
      requestAnimationFrame(() => {
        requestAnimationFrame(initializeButtonData);
      });
    });
    // Click event handler - applies pre-calculated values
    nav.addEventListener('click', (e) => {
      const button = e.target.closest('button');
      if (!button) return;
      const dataFilter = button.getAttribute('data-filter');
      if (dataFilter !== null) {
        applyTabStyles(dataFilter);
      }
    });
  }

  const specificDivs = document.querySelectorAll('.collection_div');
  const listItem = document.querySelectorAll('.secondList-li');

  specificDivs.forEach((div) => {
    var parent = div.parentElement;
    var next = parent.nextElementSibling;
    next.classList.add('collectionUl');
  });

  // Fall Back for FireFox not detecting :has pseudo Element
  document.querySelectorAll('.LastUl .greater').forEach((li) => {
    if (!li.parentElement.classList.contains('greater-grid')) {
      li.parentElement.classList.add('greater-grid');
    }
  });

  // Pre-compute dropdown heights once (no layout read on click — INP/reflow friendly)
  const DROPDOWN_PADDING = 30;
  function initializeDropdownHeights() {
    listItem.forEach((li) => {
      setTimeout(() => {
        if (li.querySelector('.collection_div') != null) return;
        const ul = li.querySelector('.LastUl');
        if (!ul) return;
        ul.style.maxHeight = 'none';
        const height = ul.scrollHeight + DROPDOWN_PADDING;
        ul.style.setProperty('--dropdown-max-height', height + 'px');
        ul.style.removeProperty('max-height');
      }, 0);
    });
  }
  initializeDropdownHeights();

  // Single delegated click — no per-item listeners, no layout read on click
  const menuDrawerEl = document.querySelector('#menu-drawer');
  if (menuDrawerEl) {
    menuDrawerEl.addEventListener('click', (e) => {
      const trigger = e.target.closest('.secondListtext');
      if (!trigger) return;
      const li = trigger.closest('.secondList-li');
      if (!li || li.querySelector('.collection_div')) return;
      li.classList.toggle('active');
    });
  }

  setTimeout(() => {
    attachEventListeners();
  }, 0);
}

const hamburgerMenuButton = document.querySelector('#hamburger-menu-button');
const menuDrawer = document.querySelector('#menu-drawer');

function attachEventListeners() {
  hamburgerMenuButton.addEventListener('click', (event) => {
    event.currentTarget.classList.toggle('active');
    menuDrawer.classList.toggle('active');
    if (menuDrawer.classList.contains('active')) {
      loadImagesInHamburgerMenu();
      document.body.style.overflow = 'hidden';
      document.body.addEventListener('touchmove', preventDefault, { passive: false });
    } else {
      document.body.style.overflow = null;
      document.body.removeEventListener('touchmove', preventDefault);
    }
  })
}

function loadImagesInHamburgerMenu() {
  const menuDrawer = document.querySelector('#menu-drawer');
  if (menuDrawer.dataset.imagesLoaded === 'true') return;

  const HamburgerMenuImages = document.querySelectorAll('#menu-drawer .mobile-nav-container-wrapper img, #menu-drawer .stickybar img');
  if (HamburgerMenuImages.length === 0) return;

  HamburgerMenuImages.forEach((img) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        img.src = img.dataset.src;
      });
    });
  });

  menuDrawer.dataset.imagesLoaded = 'true';
}

if (screen.width <= 990) {
  renderHamburgerMenu();
  if (document.readyState === 'complete') {
    loadImagesInHamburgerMenu();
  } else {
    document.addEventListener('DOMContentLoaded', loadImagesInHamburgerMenu);
  }
} else {
  document.querySelector('#hamburger-menu-button').remove();
  document.querySelector('#menu-drawer').remove();
}